import type { LucideIcon } from 'lucide-react';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/cn';

export function EmptyState({
  icon: Icon = Inbox,
  title,
  hint,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  hint?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 px-4 py-6 text-center rounded-xl border border-dashed border-zinc-800 text-zinc-400',
        className,
      )}
    >
      <Icon className="size-5 text-zinc-400" />
      <p className="text-sm font-medium text-zinc-300">{title}</p>
      {hint && <p className="text-xs text-zinc-400">{hint}</p>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
